const town = [
  {
    Código: "02",
    Municipio: "VILLA FRANCISCA",
    Códpaís: "DO"
  },
  {
    Código: "10",
    Municipio: "DUARTE",
    Códpaís: "DO"
  },
  {
    Código: "101",
    Municipio: "SAN FRANCISCO DE MACORIS",
    Códpaís: "DO"
  },
  {
    Código: "102",
    Municipio: "CASTILLO",
    Códpaís: "DO"
  },
  {
    Código: "103",
    Municipio: "VILLA RIVAS",
    Códpaís: "DO"
  },
  {
    Código: "104",
    Municipio: "PIMENTEL",
    Códpaís: "DO"
  },
  {
    Código: "105",
    Municipio: "ARENOSO",
    Códpaís: "DO"
  },
  {
    Código: "106",
    Municipio: "LAS GUARANAS",
    Códpaís: "DO"
  },
  {
    Código: "11",
    Municipio: "SANTO DOMINGO",
    Códpaís: "DO"
  },
  {
    Código: "111",
    Municipio: "SALCEDO",
    Códpaís: "DO"
  },
  {
    Código: "1113",
    Municipio: "SANTO DOMINGO",
    Códpaís: "DO"
  },
  {
    Código: "112",
    Municipio: "VILLA TAPIA",
    Códpaís: "DO"
  },
  {
    Código: "113",
    Municipio: "TENARES",
    Códpaís: "DO"
  },
  {
    Código: "114",
    Municipio: "OJO DE AGUA",
    Códpaís: "DO"
  },
  {
    Código: "1176",
    Municipio: "VILLA CARMEN",
    Códpaís: "DO"
  },
  {
    Código: "121",
    Municipio: "COTUI",
    Códpaís: "DO"
  },
  {
    Código: "122",
    Municipio: "FANTINO",
    Códpaís: "DO"
  },
  {
    Código: "123",
    Municipio: "CEVICOS",
    Códpaís: "DO"
  },
  {
    Código: "124",
    Municipio: "HATILLO COTUI",
    Códpaís: "DO"
  },
  {
    Código: "125",
    Municipio: "LA PINA",
    Códpaís: "DO"
  },
  {
    Código: "131",
    Municipio: "DAJABON",
    Códpaís: "DO"
  },
  {
    Código: "132",
    Municipio: "RESTAURACION",
    Códpaís: "DO"
  },
  {
    Código: "133",
    Municipio: "LOMA DE CABRERA",
    Códpaís: "DO"
  },
  {
    Código: "134",
    Municipio: "PARTIDO",
    Códpaís: "DO"
  },
  {
    Código: "141",
    Municipio: "SANTIAGO RODRIGUEZ",
    Códpaís: "DO"
  },
  {
    Código: "142",
    Municipio: "SABANETA",
    Códpaís: "DO"
  },
  {
    Código: "143",
    Municipio: "MONCION",
    Códpaís: "DO"
  },
  {
    Código: "144",
    Municipio: "VILLA LOS ALMACIGOS",
    Códpaís: "DO"
  },
  {
    Código: "151",
    Municipio: "MONTE CRISTY",
    Códpaís: "DO"
  },
  {
    Código: "152",
    Municipio: "VILLA VASQUEZ",
    Códpaís: "DO"
  },
  {
    Código: "153",
    Municipio: "GUAYUBIN",
    Códpaís: "DO"
  },
  {
    Código: "154",
    Municipio: "MANZANILLO",
    Códpaís: "DO"
  },
  {
    Código: "155",
    Municipio: "CASTANUELA",
    Códpaís: "DO"
  },
  {
    Código: "156",
    Municipio: "LAS MATS DE STA.CRUZ",
    Códpaís: "DO"
  },
  {
    Código: "157",
    Municipio: "PEPILLO SALCEDO",
    Códpaís: "DO"
  },
  {
    Código: "16",
    Municipio: "BOCA CHICA",
    Códpaís: "DO"
  },
  {
    Código: "161",
    Municipio: "VALVERDE,MAO",
    Códpaís: "DO"
  },
  {
    Código: "162",
    Municipio: "ESPERANZA",
    Códpaís: "DO"
  },
  {
    Código: "164",
    Municipio: "LAGUNA SALADA",
    Códpaís: "DO"
  },
  {
    Código: "165",
    Municipio: "CRUCE DE GUAYACANES",
    Códpaís: "DO"
  },
  {
    Código: "171",
    Municipio: "HIGUEY",
    Códpaís: "DO"
  },
  {
    Código: "172",
    Municipio: "SAN RAFAEL DE YUMA",
    Códpaís: "DO"
  },
  {
    Código: "173",
    Municipio: "NISIBON",
    Códpaís: "DO"
  },
  {
    Código: "174",
    Municipio: "PUNTA CANA",
    Códpaís: "DO"
  },
  {
    Código: "175",
    Municipio: "BAVARO",
    Códpaís: "DO"
  },
  {
    Código: "18",
    Municipio: "GUERRA",
    Códpaís: "DO"
  },
  {
    Código: "181",
    Municipio: "EL SEYBO",
    Códpaís: "DO"
  },
  {
    Código: "182",
    Municipio: "MICHES",
    Códpaís: "DO"
  },
  {
    Código: "19",
    Municipio: "LA CALETA",
    Códpaís: "DO"
  },
  {
    Código: "191",
    Municipio: "LA ROMANA",
    Códpaís: "DO"
  },
  {
    Código: "192",
    Municipio: "GUAYMATE",
    Códpaís: "DO"
  },
  {
    Código: "201",
    Municipio: "SAN PEDRO DE MACORIS",
    Códpaís: "DO"
  },
  {
    Código: "202",
    Municipio: "INGENIO PORVENIR",
    Códpaís: "DO"
  },
  {
    Código: "203",
    Municipio: "INGENIO CONSUELO",
    Códpaís: "DO"
  },
  {
    Código: "204",
    Municipio: "INGENIO QUISQUEYA",
    Códpaís: "DO"
  },
  {
    Código: "205",
    Municipio: "LOS LLANOS",
    Códpaís: "DO"
  },
  {
    Código: "206",
    Municipio: "RAMON SANTANA",
    Códpaís: "DO"
  },
  {
    Código: "21",
    Municipio: "BANI",
    Códpaís: "DO"
  },
  {
    Código: "211",
    Municipio: "BARAHONA",
    Códpaís: "DO"
  },
  {
    Código: "212",
    Municipio: "CABRAL",
    Códpaís: "DO"
  },
  {
    Código: "213",
    Municipio: "ENRIQUILLO",
    Códpaís: "DO"
  },
  {
    Código: "214",
    Municipio: "VICENTE NOBLE",
    Códpaís: "DO"
  },
  {
    Código: "215",
    Municipio: "PARAISO",
    Códpaís: "DO"
  },
  {
    Código: "217",
    Municipio: "SANTO DOMINGO ESTE",
    Códpaís: "DO"
  },
  {
    Código: "218",
    Municipio: "SANTO DOMINGO OESTE",
    Códpaís: "DO"
  },
  {
    Código: "22",
    Municipio: "NIZAO",
    Códpaís: "DO"
  },
  {
    Código: "221",
    Municipio: "NEIBA",
    Códpaís: "DO"
  },
  {
    Código: "222",
    Municipio: "GALVAN",
    Códpaís: "DO"
  },
  {
    Código: "223",
    Municipio: "VILLA JARAGUA",
    Códpaís: "DO"
  },
  {
    Código: "224",
    Municipio: "TAMAYO",
    Códpaís: "DO"
  },
  {
    Código: "231",
    Municipio: "PEDERNALES",
    Códpaís: "DO"
  },
  {
    Código: "234",
    Municipio: "CABO ROJO",
    Códpaís: "DO"
  },
  {
    Código: "241",
    Municipio: "DUVERGE",
    Códpaís: "DO"
  },
  {
    Código: "242",
    Municipio: "JIMANI",
    Códpaís: "DO"
  },
  {
    Código: "243",
    Municipio: "LA DESCUBIERTA",
    Códpaís: "DO"
  },
  {
    Código: "244",
    Municipio: "MELLA",
    Códpaís: "DO"
  },
  {
    Código: "245",
    Municipio: "POSTRER RIO",
    Códpaís: "DO"
  },
  {
    Código: "246",
    Municipio: "CRISTOBAL",
    Códpaís: "DO"
  },
  {
    Código: "251",
    Municipio: "SAN JUAN  DE LA MAGUANA",
    Códpaís: "DO"
  },
  {
    Código: "252",
    Municipio: "LAS MATAS DE FARFAN",
    Códpaís: "DO"
  },
  {
    Código: "253",
    Municipio: "EL CERCADO",
    Códpaís: "DO"
  },
  {
    Código: "254",
    Municipio: "JUAN DE HERRERA",
    Códpaís: "DO"
  },
  {
    Código: "255",
    Municipio: "VALLEJUELO",
    Códpaís: "DO"
  },
  {
    Código: "261",
    Municipio: "AZUA",
    Códpaís: "DO"
  },
  {
    Código: "262",
    Municipio: "PADRE LAS CASAS",
    Códpaís: "DO"
  },
  {
    Código: "263",
    Municipio: "SABANA YEGUA",
    Códpaís: "DO"
  },
  {
    Código: "264",
    Municipio: "LAS YAYAS",
    Códpaís: "DO"
  },
  {
    Código: "271",
    Municipio: "ELIAS PIÑA",
    Códpaís: "DO"
  },
  {
    Código: "281",
    Municipio: "BONAO",
    Códpaís: "DO"
  },
  {
    Código: "282",
    Municipio: "PIEDRA BLANCA",
    Códpaís: "DO"
  },
  {
    Código: "283",
    Municipio: "JUMA",
    Códpaís: "DO"
  },
  {
    Código: "284",
    Municipio: "MAIMON",
    Códpaís: "DO"
  },
  {
    Código: "291",
    Municipio: "HATO MAYOR",
    Códpaís: "DO"
  },
  {
    Código: "292",
    Municipio: "SABANA DE LA MAR",
    Códpaís: "DO"
  },
  {
    Código: "293",
    Municipio: "EL VALLE",
    Códpaís: "DO"
  },
  {
    Código: "31",
    Municipio: "SAN CRISTOBAL",
    Códpaís: "DO"
  },
  {
    Código: "311",
    Municipio: "MONTE PLATA",
    Códpaís: "DO"
  },
  {
    Código: "312",
    Municipio: "YAMASA",
    Códpaís: "DO"
  },
  {
    Código: "313",
    Municipio: "BAYAGUANA",
    Códpaís: "DO"
  },
  {
    Código: "314",
    Municipio: "SABANA GRANDE DE BOYA",
    Códpaís: "DO"
  },
  {
    Código: "32",
    Municipio: "VILLA ALTAGRACIA",
    Códpaís: "DO"
  },
  {
    Código: "321",
    Municipio: "SAN JOSE DE OCOA",
    Códpaís: "DO"
  },
  {
    Código: "33",
    Municipio: "CAMBITA",
    Códpaís: "DO"
  },
  {
    Código: "34",
    Municipio: "HATILLO SAN CRISTOBAL",
    Códpaís: "DO"
  },
  {
    Código: "35",
    Municipio: "PALENQUE",
    Códpaís: "DO"
  },
  {
    Código: "36",
    Municipio: "NIGUA",
    Códpaís: "DO"
  },
  {
    Código: "37",
    Municipio: "YAGUATE",
    Códpaís: "DO"
  },
  {
    Código: "38",
    Municipio: "NAJAYO",
    Códpaís: "DO"
  },
  {
    Código: "39",
    Municipio: "HAINA",
    Códpaís: "DO"
  },
  {
    Código: "41",
    Municipio: "SANTIAGO",
    Códpaís: "DO"
  },
  {
    Código: "410",
    Municipio: "SABANA IGLESIA",
    Códpaís: "DO"
  },
  {
    Código: "42",
    Municipio: "SAN JOSE DE LAS MATAS",
    Códpaís: "DO"
  },
  {
    Código: "43",
    Municipio: "JANICO",
    Códpaís: "DO"
  },
  {
    Código: "44",
    Municipio: "LICEY AL MEDIO",
    Códpaís: "DO"
  },
  {
    Código: "45",
    Municipio: "TAMBORIL",
    Códpaís: "DO"
  },
  {
    Código: "46",
    Municipio: "VILLA BISONO",
    Códpaís: "DO"
  },
  {
    Código: "47",
    Municipio: "VILLA GONZALES",
    Códpaís: "DO"
  },
  {
    Código: "48",
    Municipio: "NAVARETE",
    Códpaís: "DO"
  },
  {
    Código: "49",
    Municipio: "BAITOA",
    Códpaís: "DO"
  },
  {
    Código: "491",
    Municipio: "LAGUNA PRIETA",
    Códpaís: "DO"
  },
  {
    Código: "51",
    Municipio: "LA VEGA",
    Códpaís: "DO"
  },
  {
    Código: "52",
    Municipio: "JARABACOA",
    Códpaís: "DO"
  },
  {
    Código: "53",
    Municipio: "CONSTANZA",
    Códpaís: "DO"
  },
  {
    Código: "54",
    Municipio: "CRUCE MOCA (TAVERA)",
    Códpaís: "DO"
  },
  {
    Código: "55",
    Municipio: "CUTUPU",
    Códpaís: "DO"
  },
  {
    Código: "56",
    Municipio: "JIMA ABAJO",
    Códpaís: "DO"
  },
  {
    Código: "58",
    Municipio: "RIO VERDE",
    Códpaís: "DO"
  },
  {
    Código: "61",
    Municipio: "MOCA",
    Códpaís: "DO"
  },
  {
    Código: "62",
    Municipio: "GASPAR HERNANDEZ",
    Códpaís: "DO"
  },
  {
    Código: "63",
    Municipio: "CAYATANO GERMOSEN",
    Códpaís: "DO"
  },
  {
    Código: "64",
    Municipio: "JAMAO AL NORTE",
    Códpaís: "DO"
  },
  {
    Código: "66",
    Municipio: "SAN VICTOR",
    Códpaís: "DO"
  },
  {
    Código: "71",
    Municipio: "PUERTO PLATA",
    Códpaís: "DO"
  },
  {
    Código: "714",
    Municipio: "YASICA",
    Códpaís: "DO"
  },
  {
    Código: "72",
    Municipio: "LA ISABELA",
    Códpaís: "DO"
  },
  {
    Código: "73",
    Municipio: "LUPERON",
    Códpaís: "DO"
  },
  {
    Código: "74",
    Municipio: "ALTAMIRA",
    Códpaís: "DO"
  },
  {
    Código: "75",
    Municipio: "EL MAMEY",
    Códpaís: "DO"
  },
  {
    Código: "76",
    Municipio: "MONTE LLANO",
    Códpaís: "DO"
  },
  {
    Código: "77",
    Municipio: "SOSUA",
    Códpaís: "DO"
  },
  {
    Código: "78",
    Municipio: "IMBERT",
    Códpaís: "DO"
  },
  {
    Código: "79",
    Municipio: "GUANANICO",
    Códpaís: "DO"
  },
  {
    Código: "81",
    Municipio: "SAMANA",
    Códpaís: "DO"
  },
  {
    Código: "82",
    Municipio: "SANCHEZ",
    Códpaís: "DO"
  },
  {
    Código: "83",
    Municipio: "LAS TERRENAS",
    Códpaís: "DO"
  },
  {
    Código: "91",
    Municipio: "NAGUA",
    Códpaís: "DO"
  },
  {
    Código: "92",
    Municipio: "CABRERA",
    Códpaís: "DO"
  },
  {
    Código: "93",
    Municipio: "RIO SAN JUAN",
    Códpaís: "DO"
  },
  {
    Código: "94",
    Municipio: "EL FACTOR",
    Códpaís: "DO"
  },
  {
    Código: "95",
    Municipio: "CABARETE",
    Códpaís: "DO"
  },
  {
    Código: "DN",
    Municipio: "DISTRITO NACIONAL",
    Códpaís: "DO"
  },
  {
    Código: "SDE",
    Municipio: "SANTO DOMIGO ESTE ",
    Códpaís: "DO"
  },
  {
    Código: "SDN",
    Municipio: "SANTO DOMINGO NORTE ",
    Códpaís: "DO"
  },
  {
    Código: "SDS",
    Municipio: "SANTO DOMINGO SUR ",
    Códpaís: "DO"
  },
  {
    Código: "STGO",
    Municipio: "SANTIAGO",
    Códpaís: "DO"
  }
];
export default town;
